import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffSmsCanceledOrders(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-sms-canceled-orders/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQShopId('');
        setFilterQCustomerName('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    useEffect(() => {
        postData('/api/panel/page/taroff-sms-canceled-orders/table-data', {
            size: tableSize,
            page: tablePage,
            q_shop_id: filterQShopId,
            q_customer_name: filterQCustomerName,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp1 = (row) => {
        console.log('button-data-edit');
    };
    const handlecomp2 = (row) => {
        console.log('button-data-edit');
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>سفارشات لغو پیامکی</Title>
                </RightComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'نام خریدار'}
                    value={filterQCustomerName}
                    onChange={setFilterQCustomerName}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    {row.show && (
                                        <Button
                                            onClick={() => handlecomp1(row)}
                                            rightIcon={'fal fa-trash'}
                                            tooltip={'حذف'}
                                        ></Button>
                                    )}
                                    {row.show_2 && (
                                        <Button
                                            onClick={() => handlecomp2(row)}
                                            rightIcon={'fal fa-circle-exclamation-check'}
                                            tooltip={'در حال بررسی'}
                                        ></Button>
                                    )}
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
